import { getFileExtension } from '../../../utils/shared';
import { IBLSpinLoader } from '@acilearning/ibl-web-react-common';

export default function DocumentUploadProgress({ file }) {
  return (
    <div className="w-layout-hflex file-uploading-block">
      <div className="w-layout-hflex single-file-uploading-box">
        <div className="w-layout-hflex file-upload-status-icon-block">
          <IBLSpinLoader size={23} color={'#FFF'} />
        </div>
        <div className="w-layout-vflex file-upload-info-block">
          <h6 className="file-upload-name-block">{file?.name}</h6>
          <div className="file-upload-extension-block">
            {getFileExtension(file?.name)}
          </div>
        </div>
        <div className="w-layout-vflex file-upload-closer-block">
          <img
            src="/images/x-circle.svg"
            loading="lazy"
            alt=""
            className="file-upload-closer"
          />
        </div>
      </div>
    </div>
  );
}
